// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2vNea","boxTitle":"Qualiphy_boxTitle__clmkd","box":"Qualiphy_box__38qU7","toggleWrap":"Qualiphy_toggleWrap__30lGc"};